export enum ETableActionTypes {
  InitState = 'initState',
  SetPage = 'setPage',
  SetSorting = 'setSorting',
  SetFiltering = 'setFiltering',
  SetPopup = 'setPopup',
  SetCheckedRow = 'setCheckedRow',
  SetAllRowsIsChecked = 'setAllRowsIsChecked',
}
